import { useState, useMemo, useEffect } from 'react';
import { fetchZonesPOReports, fetchSubdivisionPOReports } from 'Service/ApiService';

const INITIAL_FULL_YEAR_DATA = [
  { div: '01 SUIT', budgetMtr: 80.24, saleMtr: 22.15, budgetVal: '23,394', saleVal: '6,588', bdgtPct: '-72%' },
  { div: '02 CB', budgetMtr: 11.64, saleMtr: 1.20, budgetVal: '2,422', saleVal: '245', bdgtPct: '-90%' },
  { div: '11 SH-COT', budgetMtr: 52.19, saleMtr: 11.43, budgetVal: '10,696', saleVal: '2,462', bdgtPct: '-78%' },
  { div: '12 SH-LIN', budgetMtr: 7.98, saleMtr: 1.78, budgetVal: '4,603', saleVal: '1,027', bdgtPct: '-78%' },
  { div: '13 BREEZY', budgetMtr: 16.27, saleMtr: 2.78, budgetVal: '2,955', saleVal: '535', bdgtPct: '-83%' },
  { div: '15 VELARDI', budgetMtr: 44.76, saleMtr: 7.24, budgetVal: '6,763', saleVal: '1,147', bdgtPct: '-84%' },
  { div: '21 DUET', budgetMtr: 54.77, saleMtr: 6.56, budgetVal: '5,561', saleVal: '720', bdgtPct: '-88%' }
];

const INITIAL_APR_AUG_DATA = [
  { div: '01 SUIT', budgetMtr: 26.16, saleMtr: 22.15, bdgtPct: '-15%', budgetVal: '7,655', saleVal: '6,588' },
  { div: '02 CB', budgetMtr: 3.61, saleMtr: 1.20, bdgtPct: '-67%', budgetVal: '750', saleVal: '245' },
  { div: '11 SH-COT', budgetMtr: 16.10, saleMtr: 11.43, bdgtPct: '-29%', budgetVal: '3,333', saleVal: '2,462' },
  { div: '12 SH-LIN', budgetMtr: 2.41, saleMtr: 1.78, bdgtPct: '-26%', budgetVal: '1,401', saleVal: '1,027' },
  { div: '13 BREEZY', budgetMtr: 5.07, saleMtr: 2.78, bdgtPct: '-45%', budgetVal: '930', saleVal: '535' },
  { div: '15 VELARDI', budgetMtr: 13.09, saleMtr: 7.24, bdgtPct: '-45%', budgetVal: '1,968', saleVal: '1,147' },
  { div: '21 DUET', budgetMtr: 13.84, saleMtr: 6.56, bdgtPct: '-53%', budgetVal: '1,411', saleVal: '720' }
];

const INITIAL_YTD_VOLUME_DATA = [
  { div: '01 SUIT', saleMtr2425: 15.31, saleMtr2526: 17.16, saleMtr2627: 22.15, lyGrowthPct: '29%' },
  { div: '02 CB', saleMtr2425: 2.55, saleMtr2526: 2.55, saleMtr2627: 1.20, lyGrowthPct: '-53%' },
  { div: '11 SH-COT', saleMtr2425: 5.81, saleMtr2526: 8.89, saleMtr2627: 11.43, lyGrowthPct: '29%' },
  { div: '12 SH-LIN', saleMtr2425: 1.02, saleMtr2526: 1.24, saleMtr2627: 1.78, lyGrowthPct: '44%' },
  { div: '13 BREEZY', saleMtr2425: 3.81, saleMtr2526: 3.47, saleMtr2627: 2.78, lyGrowthPct: '-20%' },
  { div: '15 VELARDI', saleMtr2425: '0.00', saleMtr2526: 4.64, saleMtr2627: 7.24, lyGrowthPct: '56%' },
  { div: '21 DUET', saleMtr2425: 5.71, saleMtr2526: 7.94, saleMtr2627: 6.56, lyGrowthPct: '-17%' }
];

const INITIAL_YTD_VALUE_DATA = [
  { div: '01 SUIT', salVal2425: '4,381', salVal2526: '4,772', salVal2627: '6,588', lyGrowthPct: '38%' },
  { div: '02 CB', salVal2425: '498', salVal2526: '513', salVal2627: '245', lyGrowthPct: '-52%' },
  { div: '11 SH-COT', salVal2425: '1,233', salVal2526: '1,776', salVal2627: '2,462', lyGrowthPct: '39%' },
  { div: '12 SH-LIN', salVal2425: '612', salVal2526: '705', salVal2627: '1,027', lyGrowthPct: '46%' },
  { div: '13 BREEZY', salVal2425: '716', salVal2526: '642', salVal2627: '535', lyGrowthPct: '-17%' },
  { div: '15 VELARDI', salVal2425: '0', salVal2526: '656', salVal2627: '1,147', lyGrowthPct: '75%' },
  { div: '21 DUET', salVal2425: '539', salVal2526: '752', salVal2627: '720', lyGrowthPct: '-4%' }
];

const INITIAL_DEALERWISE_DATA = [
  { id: 1, partyName: 'A V FABRICS', city: 'AMRITSAR', fullYear: 675, val2627: 536, ytd2628: 284, ytd2627: 536, growthPct: '188.61%' },
  { id: 2, partyName: 'R K DHAMIJA FABRICS PVT LTD', city: 'DELHI', fullYear: 794, val2627: 343, ytd2628: 206, ytd2627: 343, growthPct: '166.65%' },
  { id: 3, partyName: 'AGRAWAL TEXTILES', city: 'GORAKHPUR', fullYear: 813, val2627: 310, ytd2628: 241, ytd2627: 310, growthPct: '128.73%' },
  { id: 4, partyName: 'J D SYNTHETICS', city: 'KOLKATA', fullYear: 326, val2627: 259, ytd2628: 152, ytd2627: 259, growthPct: '169.69%' },
  { id: 5, partyName: 'PARTH TRADING CO.', city: 'DELHI', fullYear: 558, val2627: 252, ytd2628: 128, ytd2627: 252, growthPct: '196.28%' },
  { id: 6, partyName: 'AGARWAL SYNTHETICS', city: 'MUZAFFARPUR', fullYear: 690, val2627: 210, ytd2628: 204, ytd2627: 210, growthPct: '103.12%' },
  { id: 7, partyName: 'RANCHI-A K TRADERS', city: 'RANCHI', fullYear: 409, val2627: 206, ytd2628: 118, ytd2627: 206, growthPct: '174.45%' },
  { id: 8, partyName: 'SHREE RATAN TEXTILES', city: 'KOLKATA', fullYear: 407, val2627: 205, ytd2628: 124, ytd2627: 205, growthPct: '165.14%' },
  { id: 9, partyName: 'SRI R K TRADERS', city: 'KOLKATA', fullYear: 118, val2627: 198, ytd2628: 21, ytd2627: 198, growthPct: '963.64%' },
  { id: 10, partyName: 'WOOLLEN HOUSE', city: 'KANPUR', fullYear: 413, val2627: 195, ytd2628: 95, ytd2627: 195, growthPct: '204.72%' },
  { id: 11, partyName: 'R NIRAV', city: 'AHMEDABAD', fullYear: 458, val2627: 185, ytd2628: 139, ytd2627: 185, growthPct: '133.41%' },
  { id: 12, partyName: 'NAGPAL FABRIC PVT LTD', city: 'DELHI', fullYear: 513, val2627: 181, ytd2628: 116, ytd2627: 181, growthPct: '155.55%' },
  { id: 13, partyName: 'RATANLAL RAMESHWAR DAYAL', city: 'PILKHUWA', fullYear: 217, val2627: 181, ytd2628: 123, ytd2627: 181, growthPct: '146.39%' },
  { id: 14, partyName: "SHIV OM SON'S", city: 'FAZILKA', fullYear: 313, val2627: 180, ytd2628: 81, ytd2627: 180, growthPct: '221.08%' },
  { id: 15, partyName: 'NEHA SYNTHETICS', city: 'MUZAFFARPUR', fullYear: 526, val2627: 176, ytd2628: 178, ytd2627: 176, growthPct: '99.1%' },
  { id: 16, partyName: 'BHIWANDI-INFINITE VENTURE', city: 'MUMBAI', fullYear: 199, val2627: 162, ytd2628: 78, ytd2627: 162, growthPct: '208.4%' },
  { id: 17, partyName: 'PADMAVATI FABRICS', city: 'KOLKATA', fullYear: 308, val2627: 160, ytd2628: 106, ytd2627: 160, growthPct: '151.42%' },
  { id: 18, partyName: 'J J SAREES PVT LTD', city: 'KANPUR', fullYear: 660, val2627: 156, ytd2628: 240, ytd2627: 156, growthPct: '65.02%' },
  { id: 19, partyName: 'SITA TEXTILES', city: 'KATIHAR', fullYear: 322, val2627: 155, ytd2628: 92, ytd2627: 155, growthPct: '167.89%' },
  { id: 20, partyName: 'VELVET HOME', city: 'DELHI', fullYear: 609, val2627: 154, ytd2628: 183, ytd2627: 154, growthPct: '84.62%' },
  { id: 21, partyName: 'SUBHASH CHANDER RAMESH KUMAR', city: 'BATHINDA', fullYear: 200, val2627: 152, ytd2628: 52, ytd2627: 152, growthPct: '294.81%' },
  { id: 22, partyName: 'SHREEJALAN IMPEX PVT LTD.', city: 'VARANASI', fullYear: 485, val2627: 147, ytd2628: 109, ytd2627: 147, growthPct: '134.71%' },
  { id: 23, partyName: 'SHANTI FABS', city: 'HYDERABAD', fullYear: 389, val2627: 146, ytd2628: 143, ytd2627: 146, growthPct: '102.39%' },
  { id: 24, partyName: 'ROSHANLAL RAJKUMAR', city: 'KOLKATA', fullYear: 32, val2627: 143, ytd2628: 32, ytd2627: 143, growthPct: '444.93%' },
  { id: 25, partyName: 'SRI LAXMI GANESH TEXTILES', city: 'KAVALI', fullYear: 328, val2627: 141, ytd2628: 115, ytd2627: 141, growthPct: '123.34%' },
  { id: 26, partyName: 'AKASH SYNTHETICS', city: 'PATNA', fullYear: 415, val2627: 138, ytd2628: 165, ytd2627: 138, growthPct: '83.93%' },
  { id: 27, partyName: 'SHREE MADHURAM FABRICS', city: 'JAIPUR', fullYear: 318, val2627: 137, ytd2628: 80, ytd2627: 137, growthPct: '171.73%' }
];

const DEALERWISE_TOTAL = {
  partyName: 'Grand total',
  city: '',
  fullYear: '36,736',
  val2627: '11,886',
  ytd2628: '8,838',
  ytd2627: '11,886',
  growthPct: '124.38%'
};

const INITIAL_PAYMENT_OS_DATA = [
  { partyName: 'AKASH SYNTHETICS', partyCode: '5003083', gAmt: 407, netAmt: 403, l47: 69, m47: 338, m90: 305, m120: 272, m180: 162, beforeMar25: '0.00' },
  { partyName: 'LAXMI NARAYAN DINESH KUMAR', partyCode: '5005982', gAmt: 406, netAmt: 397, l47: 94, m47: 312, m90: 284, m120: 276, m180: 183, beforeMar25: '0.00' },
  { partyName: 'J D SYNTHETICS', partyCode: '5004057', gAmt: 404, netAmt: 385, l47: 120, m47: 284, m90: 184, m120: 158, m180: 53, beforeMar25: '0.00' },
  { partyName: 'AGRAWAL TEXTILES', partyCode: '5009429', gAmt: 377, netAmt: 376, l47: 188, m47: 189, m90: 125, m120: 96, m180: 0, beforeMar25: '0.00' },
  { partyName: 'AGARWAL SYNTHETICS', partyCode: '5003080', gAmt: 347, netAmt: 331, l47: 151, m47: 196, m90: 164, m120: 140, m180: 38, beforeMar25: '0.00' },
  { partyName: 'SHREE RAM FABRICS', partyCode: '5004369', gAmt: 335, netAmt: 322, l47: 72, m47: 262, m90: 240, m120: 218, m180: 167, beforeMar25: '0.00' },
  { partyName: 'SITA TEXTILES', partyCode: '5003709', gAmt: 283, netAmt: 276, l47: 87, m47: 196, m90: 160, m120: 125, m180: 42, beforeMar25: '0.00' },
  { partyName: 'NEHA SYNTHETICS', partyCode: '5004217', gAmt: 249, netAmt: 245, l47: 99, m47: 150, m90: 130, m120: 95, m180: 0, beforeMar25: '0.00' },
  { partyName: 'JUGAL KISHORE MUNDHRA', partyCode: '5002659', gAmt: 195, netAmt: 189, l47: 63, m47: 132, m90: 113, m120: 97, m180: 13, beforeMar25: '0.00' },
  { partyName: 'SHIV KUMAR AJAY KUMAR', partyCode: '5001586', gAmt: 181, netAmt: 178, l47: 3, m47: 178, m90: 163, m120: 159, m180: 59, beforeMar25: '0.00' },
  { partyName: 'REVANTA TRADE VENTURES', partyCode: '5003028', gAmt: 166, netAmt: 166, l47: 84, m47: 82, m90: 70, m120: 64, m180: 8, beforeMar25: '0.00' },
  { partyName: 'INFINITE VENTURE', partyCode: '5008004', gAmt: 154, netAmt: 154, l47: 39, m47: 115, m90: 0, m120: 0, m180: 0, beforeMar25: '0.00' },
  { partyName: 'GEETA TEXTILES AGENCY', partyCode: '5006479', gAmt: 143, netAmt: 136, l47: 27, m47: 116, m90: 87, m120: 76, m180: 18, beforeMar25: '0.00' },
  { partyName: 'SHREE MADHURAM FABRICS', partyCode: '5005171', gAmt: 125, netAmt: 125, l47: 115, m47: 10, m90: 8, m120: 4, m180: 0, beforeMar25: '0.00' },
  { partyName: 'PRAKASH TRADING', partyCode: '5010395', gAmt: 122, netAmt: 121, l47: 69, m47: 52, m90: 47, m120: 29, m180: 10, beforeMar25: '0.00' },
  { partyName: '(MUMBAI) SANDEEP FABRICS', partyCode: '5000713', gAmt: 120, netAmt: 119, l47: 41, m47: 79, m90: 60, m120: 57, m180: 2, beforeMar25: '0.10' },
  { partyName: 'AKSHAT SYNTHETICS', partyCode: '5011424', gAmt: 120, netAmt: 116, l47: 64, m47: 55, m90: 32, m120: 21, m180: 0, beforeMar25: '0.00' },
  { partyName: 'M K FABRICS', partyCode: '5007669', gAmt: 119, netAmt: 118, l47: 12, m47: 106, m90: 106, m120: 106, m180: 92, beforeMar25: '0.00' },
  { partyName: 'ROSHANLAL RAJKUMAR', partyCode: '5008994', gAmt: 117, netAmt: 71, l47: 35, m47: 82, m90: 14, m120: 0, m180: 0, beforeMar25: '0.00' },
  { partyName: 'NAVETIA & SONS', partyCode: '5012079', gAmt: 114, netAmt: 97, l47: 33, m47: 81, m90: 52, m120: 49, m180: 26, beforeMar25: '0.00' },
  { partyName: 'LAWRESHWAR TEXTILES', partyCode: '5010385', gAmt: 99, netAmt: 99, l47: 37, m47: 62, m90: 25, m120: 23, m180: 0, beforeMar25: '0.00' },
  { partyName: 'BHAVANI TEXTILE', partyCode: '5010327', gAmt: 97, netAmt: 96, l47: 34, m47: 62, m90: 60, m120: 59, m180: 38, beforeMar25: '0.00' },
  { partyName: 'NIYAZ SYNTHETICS', partyCode: '5000978', gAmt: 91, netAmt: 78, l47: 43, m47: 48, m90: 48, m120: 47, m180: 44, beforeMar25: '5.44' },
  { partyName: 'BHAGALPUR- SAROJ TEXTILE', partyCode: '5003193', gAmt: 91, netAmt: 89, l47: 68, m47: 23, m90: 18, m120: 10, m180: 1, beforeMar25: '0.00' }
];

const PAYMENT_OS_STATS = {
  gAmt: '7,856',
  netAmt: '7,244',
  l47: '3,133',
  m90: '305.13',
  m47: '4,723',
  l60: '343',
  m60: '4,380'
};

const AREA_OPTIONS = [
  { value: 'WESTERN UP', label: 'WESTERN UP' },
  { value: 'EASTERN UP', label: 'EASTERN UP' },
  { value: 'DELHI NCR', label: 'DELHI NCR' },
  { value: 'MUMBAI', label: 'MUMBAI' },
  { value: 'ALL', label: 'ALL AREAS' }
];

const MONTH_OPTIONS = [
  { value: 'APR-AUG', label: 'APR-AUG' },
  { value: 'FULL YEAR', label: 'FULL YEAR' },
  { value: 'APR', label: 'APRIL' },
  { value: 'MAY', label: 'MAY' },
  { value: 'JUN', label: 'JUNE' },
  { value: 'JUL', label: 'JULY' },
  { value: 'AUG', label: 'AUGUST' }
];

const DIV_OPTIONS = [
  { value: 'ALL', label: 'ALL DIVISIONS' },
  { value: '01 SUIT', label: '01 SUIT' },
  { value: '02 CB', label: '02 CB' },
  { value: '11 SH-COT', label: '11 SH-COT' },
  { value: '12 SH-LIN', label: '12 SH-LIN' },
  { value: '13 BREEZY', label: '13 BREEZY' },
  { value: '15 VELARDI', label: '15 VELARDI' },
  { value: '21 DUET', label: '21 DUET' }
];

const FY_MONTH_OPTIONS = ['APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC', 'JAN', 'FEB', 'MAR']
  .map((month, index) => ({ value: month, label: `${String(index + 1).padStart(2, '0')} ${month}` }));

const AgencyOnePageReportController = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const [areaOptions, setAreaOptions] = useState([]);
  const [divOptions, setDivOptions] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(FY_MONTH_OPTIONS);
  const [selectedDiv, setSelectedDiv] = useState([]);
  const [sendDate, setSendDate] = useState('20260901');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    Promise.all([
      fetchZonesPOReports(user.userCode, 'collection'),
      fetchSubdivisionPOReports(user.userCode, 'outstanding')
    ]).then(([zones, divisions]) => {
      if (!active) return;
      const areas = zones?.zones?.map((z, index) => ({
        label: z.region?.trim() || '(NO REGION)', value: `${z.zoneCode}_${index}`, zoneCode: z.zoneCode
      })) || [];
      const divs = divisions?.divisions?.map((d) => ({
        label: `${d.divCode} - ${d.divName}`, value: d.divCode
      })) || [];
      setAreaOptions(areas); setDivOptions(divs);
      setSelectedArea(areas); setSelectedDiv(divs);
    }).catch((error) => console.error('Agency one page dropdown load error:', error))
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [user.userCode]);

  // Filtered lists based on selectedDiv
  const fullYearData = useMemo(() => {
    if (!selectedDiv.length) return INITIAL_FULL_YEAR_DATA;
    return INITIAL_FULL_YEAR_DATA.filter((item) => selectedDiv.some((div) => item.div.includes(div.value)));
  }, [selectedDiv]);

  const aprAugData = useMemo(() => {
    if (!selectedDiv.length) return INITIAL_APR_AUG_DATA;
    return INITIAL_APR_AUG_DATA.filter((item) => selectedDiv.some((div) => item.div.includes(div.value)));
  }, [selectedDiv]);

  const ytdVolumeData = useMemo(() => {
    if (!selectedDiv.length) return INITIAL_YTD_VOLUME_DATA;
    return INITIAL_YTD_VOLUME_DATA.filter((item) => selectedDiv.some((div) => item.div.includes(div.value)));
  }, [selectedDiv]);

  const ytdValueData = useMemo(() => {
    if (!selectedDiv.length) return INITIAL_YTD_VALUE_DATA;
    return INITIAL_YTD_VALUE_DATA.filter((item) => selectedDiv.some((div) => item.div.includes(div.value)));
  }, [selectedDiv]);

  const dealerwiseData = useMemo(() => {
    return INITIAL_DEALERWISE_DATA;
  }, []);

  const paymentOsData = useMemo(() => {
    return INITIAL_PAYMENT_OS_DATA;
  }, []);

  // Grand totals
  const fullYearTotal = {
    div: 'Grand total',
    budgetMtr: '267.88',
    saleMtr: '53.13',
    budgetVal: '56,394',
    saleVal: '12,725',
    bdgtPct: '-80%'
  };

  const aprAugTotal = {
    div: 'Grand total',
    budgetMtr: '80.28',
    saleMtr: '53.13',
    bdgtPct: '-34%',
    budgetVal: '17,448',
    saleVal: '12,726'
  };

  const ytdVolumeTotal = {
    div: 'Grand total',
    saleMtr2425: '34.22',
    saleMtr2526: '45.89',
    saleMtr2627: '53.13',
    lyGrowthPct: '16%'
  };

  const ytdValueTotal = {
    div: 'Grand total',
    salVal2425: '7,978',
    salVal2526: '8,818',
    salVal2627: '12,726',
    lyGrowthPct: '30%'
  };

  // KPI gauges in APR-AUG
  const aprAugStats = {
    saleMtr: {
      label: '26-27 SALE MTR',
      value: '53.13',
      percentage: '66.2%',
      target: '80.29',
      progress: 66.2
    },
    saleVal: {
      label: '26-27 SAL VAL',
      value: '12,725',
      percentage: '72.9%',
      target: '17,448.35',
      progress: 72.9
    }
  };

  // YTD badges
  const ytdBadges = {
    volume: { label: 'LY Growth % (Vol)', value: '16%' },
    value: { label: 'Growth (Val)', value: '30%' }
  };

  return {
    selectedArea,
    setSelectedArea,
    selectedMonth,
    setSelectedMonth,
    selectedDiv,
    setSelectedDiv,
    sendDate,
    setSendDate,
    areaOptions,
    monthOptions: FY_MONTH_OPTIONS,
    divOptions,
    fullYearData,
    fullYearTotal,
    aprAugData,
    aprAugTotal,
    aprAugStats,
    ytdBadges,
    ytdVolumeData,
    ytdVolumeTotal,
    ytdValueData,
    ytdValueTotal,
    dealerwiseData,
    dealerwiseTotal: DEALERWISE_TOTAL,
    paymentOsData,
    paymentOsStats: PAYMENT_OS_STATS,
    loading
  };
};

export default AgencyOnePageReportController;
